"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalAccessObjects = void 0;
const GlobalAccessObjects_1 = require("./GlobalAccessObjects");
Object.defineProperty(exports, "GlobalAccessObjects", { enumerable: true, get: function () { return GlobalAccessObjects_1.GlobalAccessObjects; } });
//# sourceMappingURL=index.js.map